/* Bonfi global micro-interactions: count-up numbers on scroll into view.
   Applies to icons-row titles and any element marked [data-countup]. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var NUMBER_RE = /(\d[\d,]*)/;

  function prepare(el) {
    if (el.dataset.bonfiCountupReady) return null;
    var match = el.textContent.match(NUMBER_RE);
    if (!match) return null;
    var target = parseInt(match[1].replace(/,/g, ''), 10);
    if (!target || target < 2) return null;
    el.dataset.bonfiCountupReady = 'true';
    var node = null;
    // Find the text node containing the number so surrounding markup stays intact
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while ((node = walker.nextNode())) {
      var idx = node.textContent.indexOf(match[1]);
      if (idx === -1) continue;
      var numberNode = node.splitText(idx);
      numberNode.splitText(match[1].length);
      var span = document.createElement('span');
      span.className = 'bonfi-countup';
      span.textContent = match[1];
      numberNode.parentNode.replaceChild(span, numberNode);
      return { span: span, target: target, formatted: match[1].indexOf(',') !== -1 };
    }
    return null;
  }

  function animate(item) {
    var start = null;
    var duration = 1400;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var value = Math.round(item.target * eased);
      item.span.textContent = item.formatted ? value.toLocaleString('en-US') : String(value);
      if (t < 1) window.requestAnimationFrame(frame);
    }
    item.span.textContent = '0';
    window.requestAnimationFrame(frame);
  }

  function init() {
    var candidates = document.querySelectorAll('.icons-row-item__title, [data-countup]');
    if (!candidates.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var item = prepare(entry.target);
        if (item) animate(item);
      });
    }, { threshold: 0.6 });
    candidates.forEach(function (el) {
      if (NUMBER_RE.test(el.textContent)) observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  var selector = '.siblings__button[data-tooltip]:not([data-size])';
  function label(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var buttons = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) buttons.unshift(root);
    buttons.forEach(function (button) {
      var title = button.getAttribute('data-tooltip') || '';
      var match = title.match(/(\d+(?:\.\d+)?)\s*oz/i);
      button.setAttribute('data-size', match ? match[1] + ' oz' : title);
    });
  }
  label(document);
  document.addEventListener('shopify:section:load', function (event) { label(event.target); });
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) { label(node); });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
